import { render, staticRenderFns } from "./UserEditTabAddress.vue?vue&type=template&id=90f2dd6e&"
import script from "./UserEditTabAddress.vue?vue&type=script&lang=js&"
export * from "./UserEditTabAddress.vue?vue&type=script&lang=js&"
import style0 from "./UserEditTabAddress.vue?vue&type=style&index=0&id=90f2dd6e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports